// Test Mode Configuration
// Set to true to disable all premium/payment features for testing

export const TEST_MODE = {
  // Disable Stripe/payments entirely
  DISABLE_PAYMENTS: false,

  // Make all users premium automatically
  AUTO_PREMIUM: false,

  // Skip auth requirements for testing
  SKIP_AUTH: false, // Keep auth enabled but make premium free

  // Show test mode indicator
  SHOW_INDICATOR: false,

  // Enable all features regardless of subscription
  UNLOCK_ALL_FEATURES: false,
}

// Feature flags - all enabled in test mode
export const FEATURES = {
  // Garden limits
  MAX_GARDENS: TEST_MODE.UNLOCK_ALL_FEATURES ? 999 : 3,
  
  // Plant database access
  PLANT_ACCESS: TEST_MODE.UNLOCK_ALL_FEATURES ? 'all' : 'limited', // 'all' or 'limited'
  MAX_PLANTS_FREE: 5,
  
  // AI features
  AI_ASSISTANT: true,
  COMPANION_PLANTING: true,
  
  // Tracking features
  HARVEST_TRACKING: true,
  TASK_MANAGEMENT: true,
  
  // Export features
  EXPORT_PDF: true,
  EXPORT_CSV: true,
  EXPORT_IMAGE: true,
  
  // Community features
  COMMUNITY_FEED: true,
  SHARING: true,
}

// Helper to check if user has premium access
export const hasPremiumAccess = (user: any): boolean => {
  if (TEST_MODE.AUTO_PREMIUM) return true
  return user?.isPremium || false
}

// Helper to check feature availability
export const isFeatureAvailable = (feature: keyof typeof FEATURES): boolean => {
  if (TEST_MODE.UNLOCK_ALL_FEATURES) return true
  const value = FEATURES[feature]
  return typeof value === 'boolean' ? value : true
}
